import { useLocation } from '@reach/router';
import '@redneckz/uni-jsx/lib/setup.react';
import { Footer } from '@redneckz/wildless-cms-uni-blocks/lib/components/Footer/Footer';
import { Header } from '@redneckz/wildless-cms-uni-blocks/lib/components/Header/Header';
import { env } from '@redneckz/wildless-cms-uni-blocks/lib/Env';
import { useClickHandler } from '@redneckz/wildless-cms-uni-blocks/lib/hooks/useClickHandler';
import { useRouter } from '@redneckz/wildless-cms-uni-blocks/lib/hooks/useRouter';
import {
  projectSettings,
  type ProjectSettings,
} from '@redneckz/wildless-cms-uni-blocks/lib/ProjectSettings';
import { DialogManager } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/DialogManager/DialogManager';
import React, { type ReactNode } from 'react';
import wlc from '../../.wlc.json';
import { ENV } from './env';
import { isPremiumUltra } from './isPremiumUltra';
import { BodyWrapper, HeaderWrapper, LayoutWrapper } from './LayoutWrapper';
import { routerSetup } from './routerSetup';

import PremiumLogo from '../../content/assets/premium-logo-main.svg';

export interface Props {
  children: ReactNode;
  pageContext: Record<string, any>;
  data?: Record<string, any>;
}

projectSettings.setup(wlc as ProjectSettings);
env.setup(ENV);

const Layout = ({ children, pageContext, data }: Props) => {
  const location = useLocation();

  const IS_PREMIUM = isPremiumUltra(
    pageContext?.directions,
    data?.contentJson?.direction?.directionType,
  );

  // temp dirty hack
  const customLogo = {
    image: { src: IS_PREMIUM ? PremiumLogo : '/wcms-resources/rshb-logo-25-years.svg' },
  };

  useRouter.setup(routerSetup(location));
  useClickHandler();

  return (
    <LayoutWrapper
      pageContext={pageContext}
      yandexMetrikaId={projectSettings.YANDEX_METRIKA_ID}
      isPremiumUltra={IS_PREMIUM}
    >
      {(headerProps, fallback) => {
        const FIXED_FALLBACK = {
          ...fallback,
          common: {
            ...fallback.common,
            logo: customLogo,
          },
        };

        return (
          <>
            <section className="@container relative bg-main-divider">
              <HeaderWrapper>
                <Header
                  logo={customLogo}
                  {...headerProps}
                  portal={fallback.portalData}
                  header={fallback.header}
                  options={{
                    page: {
                      ...fallback,
                    },
                  }}
                />
              </HeaderWrapper>
              <BodyWrapper>
                {children}
                <Footer
                  className="col-span-12"
                  footer={fallback.footer}
                  options={{
                    page: {
                      ...FIXED_FALLBACK,
                    },
                  }}
                />
              </BodyWrapper>
            </section>
            <DialogManager />
          </>
        );
      }}
    </LayoutWrapper>
  );
};

export default Layout;
